import { Component, forwardRef, Inject, Input } from '@angular/core';
import { BlockUI, NgBlockUI }                   from 'ng-block-ui';
import { NgbActiveModal }                       from '@ng-bootstrap/ng-bootstrap';
import { TranslateService }                     from '@ngx-translate/core';

import { BookingsAppointmentTypeModel } from './typings/bookings.appointment-type';
import { BookingsService }              from './bookings.service';
import { LaborProductModel }            from '../products/models/labor-product';
import { MessagesService }              from '../messages/messages.service';

@Component({
  selector   : 'wor-bookings-appointment-type',
  template: require('./bookings.appointment-type.component.html')
})
export class BookingsAppointmentTypeComponent {
  @BlockUI('appointmentTypeBlock') block: NgBlockUI;

  @Input() appointmentType: BookingsAppointmentTypeModel;

  constructor (
    public  activeModal     : NgbActiveModal,
    @Inject(forwardRef(() => BookingsService))
    private bookingsService : BookingsService,
    private messagesService : MessagesService,
    private translateService: TranslateService
  ) {}

  delete () : void {
    this.bookingsService.deleteAppointmentType(this.appointmentType)
    .then(() => this.activeModal.close(this.translateService.instant('JS_SPACE.MESSAGES.DELETED.BOOKING_TYPE')))
    .catch(error => this.messagesService.error(error));
  }

  onProductSelect ( product : LaborProductModel ) : void {
    this.appointmentType.product_id        = product.id;
    this.appointmentType.product_item_code = product.item_code;
  }

  save () : void {
    this.block.start();

    Promise.resolve()
    .then(() => this.appointmentType.id
      ? this.bookingsService.updateAppointmentType(this.appointmentType)
        .then(() => Promise.resolve())
      : this.bookingsService.createAppointmentType(this.appointmentType)
        .then(() => Promise.resolve()))
    .then(() => this.activeModal.close(this.translateService.instant('JS_SPACE.MESSAGES.SAVED.BOOKING_TYPE')))
    .catch(error => this.messagesService.error(error))
    .finally(() => this.block.stop());
  }
}
